import { Grid, Typography } from "@mui/material";
import IDayliPlanAppointment from "../interface/iDayliPlanAppointment";

const Email = ({
  appointment,
}: {
  appointment: IDayliPlanAppointment;
}): React.JSX.Element => (
  <Grid
    item
    xs={12}
    sm={6}
    md={3}
    lg={4}
    sx={{
      mb: 2,
    }}
  >
    <Typography
      sx={{
        fontWeight: "bold",
      }}
      variant="caption"
      component="p"
    >
      Email
    </Typography>
    <Typography variant="body1" component="p">
      {appointment.participantEmail}
    </Typography>
  </Grid>
);

export default Email;
